<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
	<path class="bright" d="M8,1H6C4.35,1,3,2.35,3,4v4h5V1z" />
	<path class="dim" d="M10,1H9v1h1c1.1,0,2,0.9,2,2v6c0,2.21-1.79,4-4,4s-4-1.79-4-4V9H3v1c0,2.76,2.24,5,5,5s5-2.24,5-5V4C13,2.35,11.65,1,10,1z" />
</svg></template>